export default class User {
    constructor({ userId, name }) {
        this.userId = userId;
        this.name = name;
    }
}